export const campaignStatusArray = ['Closed', 'Draft', 'Open'] as const;
export type CampaignStatus = (typeof campaignStatusArray)[number];
